// 設備的存取來源與不能做的原因（SPEC #device-permissions-ui、#me-devices）：
// 來源（我自己的 / 組織授權給我 / 別人分享給我）、到期、其他路徑，以及 denied 的白話原因（deny.*，不顯示工程用語）。
import { useTranslation } from 'react-i18next';
import type { DeviceAccess } from '../lib/devices';
import { denialText, uniqueDenials } from '../lib/denial';
import { dateStamp } from '../lib/timefmt';

export function AccessInfo({ access }: { access: DeviceAccess | undefined }) {
  const { t, i18n } = useTranslation();
  if (!access) return null;
  const denied = uniqueDenials(access.denied).filter((d) => d.reason !== 'not_granted');
  const sharer = access.share?.sharer_display_name;
  return (
    <div className="access-info" data-testid="access-info" data-source={access.source}>
      <span className={`chip src-${access.source}`}>{t(`scope.src_${access.source}`)}</span>
      {access.share?.grantee_kind === 'org' && <span className="chip">{t('scope.external')}</span>}
      {sharer && <span className="small muted">{t('access.shared_by', { name: sharer })}</span>}
      {access.expires_at && <span className="small muted">{t('access.expires', { date: dateStamp(access.expires_at) })}</span>}
      {access.other_sources.length > 0 && (
        <span className="small muted">
          {t('access.also_via', {
            list: access.other_sources
              .map((o) => (o.sharer_display_name ? `${t(`scope.src_${o.source}`)}（${o.sharer_display_name}）` : t(`scope.src_${o.source}`)))
              .join(t('common.list_sep')),
          })}
        </span>
      )}
      {denied.length > 0 && (
        <ul className="denied-list" data-testid="denied-list">
          {denied.map((d, i) => (
            <li key={i}>
              {t(`actions.${d.action}`, { defaultValue: d.action })}
              {t('common.colon')}
              {denialText(t, d, i18n.language)}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
